import ActionTypeFact from "../ActionTypeFact";

export default class FinalizarComando extends ActionTypeFact {

    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }

}